import { useCancelRechargeMutation, useGetRechargeByIdQuery, useUpdateRechargeDataMutation, } from '../services/benefitApi';
export function useRecharge(options = {}) {
    const { voucherContractId, rechargeId, enabled = true } = options;
    const { data, isLoading, isFetching, refetch, isSuccess, isError } = useGetRechargeByIdQuery({
        voucherContractId: voucherContractId,
        rechargeId: rechargeId,
    }, {
        skip: !enabled || !voucherContractId || !rechargeId,
        refetchOnMountOrArgChange: true,
    });
    const [updateRechargeData, { isLoading: isUpdating, isError: isUpdateError, isSuccess: isUpdateSuccess, error: updateError, reset: resetUpdate, },] = useUpdateRechargeDataMutation();
    const [cancelRechargeData, { isLoading: isCanceling, isError: isCancelError, isSuccess: isCancelSuccess, reset: resetCancel },] = useCancelRechargeMutation();
    const updateRecharge = async (data) => {
        if (!voucherContractId || !rechargeId) {
            throw new Error('voucherContractId and rechargeId are required');
        }
        await updateRechargeData({
            voucherContractId,
            rechargeId,
            body: data,
        });
    };
    const cancelRecharge = async () => {
        if (!voucherContractId || !rechargeId) {
            throw new Error('voucherContractId and rechargeId are required');
        }
        await cancelRechargeData({
            voucherContractId,
            rechargeId,
        });
    };
    return {
        recharge: data || null,
        isLoading,
        isFetching,
        isError,
        refetch,
        isSuccess,
        updateRecharge,
        isUpdating,
        isUpdateError,
        isUpdateSuccess,
        updateError,
        resetUpdate,
        cancelRecharge,
        isCanceling,
        isCancelError,
        isCancelSuccess,
        resetCancel,
    };
}
